import { formatReviewSubjectType } from "@/components/pages/efteruddannelse/utils/reviewSubjectType";
import { IColumn } from "@/interfaces/table";

export type ReviewThreadColumnField =
  | "assignedAdminDisplayName"
  | "ownerDisplayName"
  | "subjectType"
  | "status"
  | "commentCount"
  | "lastCommentAt"
  | "assignedAt"
  | "resolvedByAdminDisplayName"
  | "resolvedAt"
  | "createdAt"
  | "updatedAt"
  | "subjectId"
  | "documentId";

const formatDateTime = (value: unknown) => {
  if (!value) return "-";
  return new Date(String(value)).toLocaleString("da-DK");
};

export const defaultReviewThreadColumns: IColumn<ReviewThreadColumnField>[] = [
  {
    field: "ownerDisplayName",
    title: "Person",
    active: true,
    format: "string",
    link: (row) => `/person/${row.ownerUserId}`,
  },
  {
    field: "subjectType",
    title: "Type",
    active: true,
    format: "custom",
    customValue: (value) => formatReviewSubjectType(String(value ?? "")),
  },
  {
    field: "status",
    title: "Status",
    active: true,
    format: "string",
  },
  {
    field: "commentCount",
    title: "Kommentarer",
    active: true,
    format: "number",
  },
  {
    field: "lastCommentAt",
    title: "Seneste kommentar",
    active: true,
    format: "custom",
    customValue: formatDateTime,
  },
  {
    field: "assignedAt",
    title: "Tildelt",
    active: false,
    format: "custom",
    customValue: formatDateTime,
  },
  {
    field: "resolvedByAdminDisplayName",
    title: "Løst af",
    active: false,
    format: "string",
  },
  {
    field: "resolvedAt",
    title: "Løst",
    active: false,
    format: "custom",
    customValue: formatDateTime,
  },
  {
    field: "assignedAdminDisplayName",
    title: "Tildelt til",
    active: true,
    format: "string",
  },
  {
    field: "createdAt",
    title: "Oprettet",
    active: true,
    format: "date",
  },
  {
    field: "updatedAt",
    title: "Opdateret",
    active: false,
    format: "date",
  },
];
